import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api/base-api.service';
import { STUDIO_PORTAL_API_PATHS } from 'src/assets/constants/apiPaths';

export interface CorporateUserRegistrationRequest {
  emailAddress: string;
}

export interface CorporateUserRegistrationResponse {
  success: boolean;
  message: string;
  errorMessages: any;
  responseDto: {
    userProfileId: number;
    emailAddress: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private readonly baseApiService: BaseApiService) { }

  registerCorporateUser(email: string): Observable<CorporateUserRegistrationResponse> {
    const payload: CorporateUserRegistrationRequest = {
      emailAddress: email
    };

    const endpoint = STUDIO_PORTAL_API_PATHS.add_corporate_user;
    return this.baseApiService.post<CorporateUserRegistrationResponse>(endpoint, payload);
  }
}
